const usNumberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

const usIntegerFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

/**
 *
 * @param {string=} value
 * @param {string=} culture
 */
export function formatDate(value, culture) {
  return value ? new Date(value).toLocaleDateString(culture) : '';
}

/**
 *
 * @param {number} value
 * @param {string=} culture
 */
export function formatNumber(value, culture) {
  return culture
    ? new Intl.NumberFormat(culture, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value)
    : usNumberFormatter.format(value);
}

/**
 *
 * @param {number} value
 * @param {string=} culture
 */
export function formatNumberAsInteger(value, culture) {
  return culture
    ? new Intl.NumberFormat(culture, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value)
    : usIntegerFormatter.format(value);
}
